import React from "react";
import classNames from "classnames";
import ImageLoader from "react-imageloader";
import TransitionWarning from "common/ui/components/transitionWarning/TransitionWarning";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./LoginMode.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export class LoginMode extends React.Component {
    render() {
        return (React.createElement("div", { className: styles.container },
            React.createElement(ImageLoader, { className: classNames(styles.background, styles.backgroundFader), src: "/content/images/login-background.jpg" }),
            React.createElement(TransitionWarning, null),
            this.props.children));
    }
}
